import { render, staticRenderFns } from "./BedNumbers.vue?vue&type=template&id=119c0b82&"
import script from "./BedNumbers.vue?vue&type=script&lang=js&"
export * from "./BedNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports